import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { trim } from 'lodash';

/** @dynamic */
@Injectable({
  providedIn: 'root',
})
export class CookieService {
  private _expireDays = 30; // same as refresh token on OAuth
  private _domain: string;

  constructor(@Inject(DOCUMENT) private _document: Document) {}

  init(domain: string) {
    this._domain = domain;
  }

  getCookie(key: string) {
    const cookies: string[] = this._document.cookie.split(';');
    const cookieName = key + '=';

    for (let i = 0; i < cookies.length; i++) {
      const cookie = trim(cookies[i]);

      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    return '';
  }

  getAllCookies(): string {
    return this._document.cookie;
  }

  setCookie(
    key: string,
    value: string | number | boolean,
    expireDays: number = this._expireDays,
    path: string = '/',
    domain: string = this._domain
  ) {
    const d: Date = new Date();

    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);

    let cookie = `${key}=${value};expires=${d.toUTCString()};path=${path}`;

    if (domain) {
      cookie += `;domain=${domain}`;
    }

    this._document.cookie = cookie;
  }

  removeCookie(key: string, path: string = '/', domain: string = this._domain) {
    this.setCookie(key, '', -1, path, domain);
  }
}
